export class WatchersController {
    constructor(XRayUIPermissions, $state, $scope, $timeout, WatchersDao, JFrogGridFactory, JFrogModal, ScanDao,
                IgnoreDao, $location, AlertsDao, $q, uiGridConstants, $stateParams, $filter, commonGridColumns) {
        this.$scope = $scope;
        this.$state = $state;
        this.$location = $location;
        this.$timeout = $timeout;
        this.commonGridColumns = commonGridColumns;
        this.$filter = $filter;
        this.ignoreDao = IgnoreDao;
        this.$stateParams = $stateParams;
        this.watchersDao = WatchersDao;
        this.scanDao = ScanDao;
        this.jfrogGridFactory = JFrogGridFactory;
        this.modal = JFrogModal;
        this.XRayUIPermissions = XRayUIPermissions;
        this.$q = $q;
        this.alertsDao = AlertsDao;
        this.uiGridConstants = uiGridConstants;
        this._createGrid();
        this._createAdditionalGrids();
        this._getWatchers();
        this.currentTab = 'watchers';
        this.dateRangeStart = new Date();
        this.dateRangeEnd = new Date();
        this.defaultPagination = {
direction: 'desc', num_of_rows: 20, order_by: 'created_at', page_num: 1
};
        this.tabs = [{name: 'watchers'}, {name: 'ignoreRules'}, {name: 'user'}];
        this.baseTabsDict = {watchers: 'Watches', ignoreRules: 'Ignore Rules'};
        this.tabsDict = _.cloneDeep(this.baseTabsDict);
        this.dateRangeOpts = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: 'Apply',
                fromLabel: 'From',
                format: 'YYYY-MM-DD',
                toLabel: 'To',
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            }
        };

    }

    _createGrid() {
        this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getColumns())
            /*
                        .setMultiSelect()
            */
            .setButtons(this._getActions());
        //            .setBatchActions(this._getAlertsBatchActions());
    }


    deleteWatcher(watcher) {
        this.modal.confirm(`Are you sure you want to delete watch '${watcher.general_data.name}?'`)
            .then(() => {
                this.watchersDao.delete({}, {watcherName: watcher.general_data.name}).$promise.then((res) => {
                    this._getWatchers();
                });
            });
    }

    _getWatchers() {
        this.watchersDao.getAll().$promise.then((data) => {
            //            data.forEach((d)=>d.alerts_per_watch=8)
            data.forEach((watch) => {
                if (watch.target_type === 'builds') {
                    watch.target = 'All Builds';
                }
                else {
                    watch.target = watch.target_type !== 'artifact' ? `${watch.art_id}::${watch.target_type}::${watch.target_name}` : 'Every Artifact';
                }

            });
            _.each(data, (val, key) => {
                console.log("VAL IS", val);
                val.policies = _.map(val.policies, 'name');
            });

            this.gridOptions.setGridData(data);
            this.setTabCounter(data.length);
        });


    }

    _getColumns() {
        return [
            {
                name: 'Name',
                displayName: 'Name',
                field: 'general_data.name',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="watchers.edit({watcherName: row.entity.general_data.name})"><a  class="jf-link" href="">{{row.entity.general_data.name}}</a><span ng-if="row.entity.system" class="system-watch">System</span></div>',
                width: '25%'
            },
            {
                name: 'Resources',
                displayName: 'Resources',
                field: 'resources',
                cellTemplate: '<div class="jf-link ui-grid-cell-contents" ><a ng-click="grid.appScope.Watchers.showResources(row.entity)" class="jf-link" >View Resources ({{row.entity.project_resources.resources.length}})</a></div>',
                width: '30%',
                customActions: [{
                    icon: 'icon icon-run',
                    tooltip: 'Apply on Existing Content',
                    callback: row => this.applyOnExistingContent(row),
                    visibleWhen:
                        row => row.general_data.active && (_.filter(row.project_resources.resources, (r) => r.type == 'builds' || r.type == 'all-repos').length !== row.project_resources.resources.length) && row.permissions.manageable
                }]
            },
            {
                name: 'policies',
                field: 'policy',
                displayName: 'Policies',
                cellTemplate: this.commonGridColumns.listableColumn('row.entity.policies', 'row.entity.name', null, false),
                width: '30%'
            },
            {
                name: 'Violations',
                displayName: 'Violations',
                field: 'violations',
                cellTemplate: `<div class="ui-grid-cell-contents"> <span ng-if="row.entity.numOfViolation == 'No Violations'">No Violations</span> <span ng-if="row.entity.numOfViolation">{{row.entity.numOfViolation | number}}</span> <span ng-if="!row.entity.numOfViolation"><a ng-click="grid.appScope.Watchers.getViolationCount(row.entity)">Calculate</a></span> </div>`,
                width: '20%'
            },
            {
                name: 'Enabled',
                displayName: 'Enabled',
                field: 'active',
                cellTemplate: `<div style="text-align:center;font-size: 20px" class="ui-grid-cell-contents enable-status" ng-class="row.entity.general_data.active ? 'icon-notif-success' : 'icon-notif-error'"></div>`,
                width: '10%'
            }
        ];
    }

    showResources(row) {
        console.log("need to show resources for", row);

        const modalScope = this.$scope.$new();

        this.listGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getListColumns())
            .setRowsPerPage(8)
            .setGridData(row.project_resources.resources);
        modalScope.modalTitle = `'${row.general_data.name}' Watch Resources `;
        modalScope.gridOptions = this.listGridOptions;
        this.$timeout(() => {
            modalScope.gridOptions.api.grouping.groupColumn('Type');
        });
        this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/show_list_grid_modal.html'), modalScope).result.then(() => {
        });


    }


    _getListColumns() {
        return [
            {
                displayName: 'Type',
                name: 'Type',
                field: 'type',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{grid.appScope.Watchers.getResourceType(row.entity.type) | capitalizeFirst}}</div>`,
                width: '33%'
            },
            {

                displayName: 'Name',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.name}}</div>`,
                field: 'name',
                width: '34%'
            },
            {
                name: 'instace',
                displayName: 'Instance',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{grid.appScope.Watchers.getInstance(row.entity) }}</div>`,
                field: 'bin_mgr_id',
                sort: {
                    direction: this.uiGridConstants.ASC
                },
                width: '33%'
            }
        ];
    }

    getResourceType(type) {

        if (type == "all-repos") {
            return "Repositories";
        }
        if (type == "builds") {
            return "Builds";
        }
        return type;
    }

    getInstance(row) {
        if (row.type == "all-repos" || row.type == "builds") {
            return "All Instances";
        }
        return row.bin_mgr_id;
    }

    getViolationCount(row) {

        this.watchersDao.getViolationsCount({}, {watcherId: row.general_data.id}).$promise.then((response) => {

            if (response.num_of_violations == 0) {
                row.numOfViolation = 'No Violations';
            } else {

                row.numOfViolation = response.num_of_violations;
            }
        });


    }

    _getActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteWatcher(row),
                visibleWhen: (row) => !row.system && row.permissions.deletable
            }

        ];
    }

    setWatcherEnabled(watcherName, enabled) {
        this.watchersDao.getOne({}, {watcherName}).$promise.then((data) => {
            data.active = enabled;
            data.watcherName = data.name;
            this.watchersDao.update(data);
        });
    }

    gotoAlerts(watcherName) {
        this.$state.go('alerts', {watcherNameFilter: watcherName});
    }

    applyOnExistingContent(row) {
        const modalScope = this.modalScope = this.$scope.$new();
        let modalInstance;

        modalScope.watchName = row.general_data.name;
        modalScope.watchTarget = row.project_resources.resources;
        modalScope.selection = {};
        this.datePicker = {startDate: null, endDate: null};
        this.dateRangeOpts = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: 'Apply',
                fromLabel: 'From',
                format: 'YYYY-MM-DD',
                toLabel: 'To',
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            }
        };
        this.$scope.date = {};
        this.$scope.$watch('date', (newDate) => {
            if (newDate.startDate && newDate.endDate) {
                const start = new Date(newDate.startDate._d).getTime();
                const end = new Date(newDate.endDate._d).getTime();
                const final = start + '-' + end;
                this.custom_range = final;
            }
        }, false);
        modalScope.columns = [
            {
                header: "Name",
                field: "name",
                width: "33%",

            },
            {
                header: "Type",
                field: "type",
                cellTemplate: `<div disable-tooltip-on-overflow style="display:flex;flex-direction:row"> <div style="line-height: 28px;flex-shrink:1" jf-tooltip-on-overflow>{{row.entity.type | capitalizeFirst}}</div></div>`,
                width: "34%",
            },
            {
                header: "Instance",
                field: "bin_mgr_id",
                width: "33%",

            }
        ];
        modalScope.ctrl = this;
        modalScope.excludeList = _.cloneDeep(row.project_resources.resources);
        _.remove(modalScope.excludeList, (r) => r.type == 'builds' || r.type == 'all-repos');
        modalScope.includeList = [];
        modalScope.timeSpanOptions = [
            {text: 'Last 7 Days', value: '7d'},
            {text: 'Last 14 Days', value: '14d'},
            {text: 'Last 30 Days', value: '30d'},
            {text: 'Last 90 Days', value: '90d'},
            {text: 'Custom Range', value: 'CUSTOM'}
        ];
        modalScope.selection.selectedTimeSpan = modalScope.timeSpanOptions[0];
        modalScope.onChangeTimeSpan = () => {
            if (modalScope.selection.selectedTimeSpan.value == 'CUSTOM') {
                $('#daterange3').click();
                time_range = modalScope.selection.selectedTimeSpan;
            }
        };

        modalScope.onChangeTimeSpan();

        modalScope.apply = () => {
            modalInstance.close();
            let time_range;
            if (modalScope.selection.selectedTimeSpan.value == 'CUSTOM') {
                time_range = this.custom_range;
            } else {
                time_range = modalScope.selection.selectedTimeSpan.value;
            }
            const payload = {
                time_range,
                watch_id: row.general_data.id,
                selected_resources: modalScope.includeList
            };
            this.scanDao.historyScan({}, payload).$promise.then((response) => {
            });
        };

        modalInstance = this.modal.launchModalWithTemplateMarkup(require('../../../../modal_templates/xray_modals/apply_watch_on_existing_content_modal.html'), modalScope);

    }

    initAndBindDatepickerElement(elemId, model, scope, changeCallback) {
        this.$timeout(() => {
            $('#' + elemId).datepicker({
                dateFormat: 'dd-mm-yy',
                maxDate: scope.today,
                showOn: 'none',
                onSelect: (date, dp) => {
                    const selectedDate = new Date(dp.selectedYear, dp.selectedMonth, dp.selectedDay);
                    _.set(scope, model, selectedDate);
                    scope.$apply();
                    changeCallback(selectedDate);
                },
                onClose: (date, dp) => {
                    scope.datePickerOpened = false;
                    scope.$apply();
                }
            });
            $('#' + elemId).datepicker('setDate', _.get(scope, model));
            changeCallback(_.get(scope, model));
        });
    }

    openDatePicker(e) {
        $(e.srcElement).datepicker('show');
        this.modalScope.datePickerOpened = true;
    }


    update(dateRangeStart, dateRangeEnd) {
        this.optionsFrom.maxDate = dateRangeEnd;
        this.optionsTo.minDate = dateRangeStart;
        this.optionsTo.maxDate = new Date();
        this.dateRangeEnd = dateRangeEnd;
        this.dateRangeStart = dateRangeStart;

    }


    // *** NEW TABS IN WATCHER ** //

    _createAdditionalGrids() {
        this.userAlertsGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getAlertsColumns())
            .setRowsPerPage(20)
            .setExternalPagination((pagination) => this._getAlerts(pagination))
            .setGridData([]);

        this.userAlertsGridOptions.isRowSelectable = (row) => {
            if (!row.entity.permissions) {
                return true;
            }
            return row.entity.permissions.manageable;
        };


        this.ignoreGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getIgnoreColumns())
            .setButtons(this._getIgnoreActions());


        if (this.$stateParams.watcherNameFilter) {
            const f = () => {
                if (this[this.getCurrentAlertGrid()].setFilter) {
                    this[this.getCurrentAlertGrid()].setFilter(
                        this.$stateParams.watcherNameFilter
);
                } else {
                    this.$timeout(f);
                }
            };
            this.$timeout(f);
        }


    }


    _getAlertsColumns() {
        return [
            {
                name: 'Trigger',
                displayName: 'Trigger',
                field: 'trigger',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.trigger}}</div>',
                width: '44%'
            },
            {
                name: 'Top Severity',
                displayName: 'Top Severity',
                field: 'top_severity',
                cellTemplate: '<div class="ui-grid-cell-contents severity" ui-sref="alerts.details({alertID: row.entity.id})"><div class="severity-colorbar" ng-class="(row.entity.top_severity || \'Unknown\').toLowerCase()"></div>{{row.entity.top_severity || \'Unknown\'}}</div>',
                //                enableSorting: false,
                width: '10%'
            },
            {
                name: 'Watch',
                displayName: 'Watch',
                field: 'watch_name',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.watch_name}} ({{row.entity.target}}) {{row.entity.watch_id ? "" : " [DELETED]"}}</div>',
                width: '15%',
                customActions: [{
                    icon: 'icon icon-arrow',
                    tooltip: 'View Watch',
                    callback: row => this.gotoWatch(row),
                    visibleWhen: (row) => (this.currentTab === 'user' || row.user_name == this.user.userName) && row.watch_id
                }]
            },
            {
                name: 'Timestamp',
                displayName: 'Timestamp',
                field: 'created_at',
                cellTemplate: `<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.created_at | date:'medium'}}</div>`,
                sort: {
                    direction: this.uiGridConstants.DESC
                },
                width: '15%'
            },
            {
                name: 'Issues',
                displayName: 'Issues',
                field: 'num_of_issues',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.num_of_issues}}</div>',
                enableSorting: false,
                width: '8%'
            },
            {
                name: 'Artifacts',
                displayName: 'Artifacts',
                field: 'num_of_artifacts',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.num_of_artifacts}}</div>',
                enableSorting: false,
                width: '8%'
            }
        ];

    }

    _getIgnoreColumns() {
        return [
            {
                name: 'Issues',
                displayName: 'Violations',
                field: 'issuesCount',
                cellTemplate: '<div ng-if="row.entity.issues.length > 1" class="ui-grid-cell-contents">{{row.entity.issues.length}} <strong jf-tooltip="{{row.entity.issuesSummary}}">(See List)</strong></div>'
                + '<div ng-if="row.entity.issues.length === 1" class="ui-grid-cell-contents">{{row.entity.issuesSummary}}</div>',
                width: '20%'
            },
            {
                name: 'Watch Name',
                displayName: 'Watch Name',
                field: 'watch_name',
                width: '20%'
            },
            {
                name: 'Watch Target',
                displayName: 'Watch Target',
                field: 'watch_target',
                width: '20%'
            },
            {
                name: 'policies',
                field: 'policy',
                displayName: 'Policies',
                cellTemplate: this.commonGridColumns.listableColumn('row.entity.policies', 'row.entity.issues[0].summary', null, false),
                width: '15%'
            },
            {
                name: 'Creation Time',
                displayName: 'Creation Time',
                cellTemplate: `<div class="ui-grid-cell-contents creation-time-col"  >{{row.entity.created | date:'medium' }}</div>`,
                field: 'created',
                width: '25%'
            }
        ];
    }


    onChangeTab(tab) {

        const oldTab = this.currentTab;
        this.currentTab = tab.name;
        if (oldTab !== this.currentTab) {
            if (tab.name === 'ignoreRules') {
                this._getIgnoreRules();
            }
            else {

            }
        }
    }

    _getIgnoreRules() {
        this.ignoreDao.get().$promise.then((ignoreRules) => {
            ignoreRules.forEach((rule) => {
                rule.issuesSummary = _.map(rule.issues, 'summary').join('<br/>');
                rule.watch_target = this._getWatchTarget(rule);
            });
            this.ignoreGridOptions.setGridData(ignoreRules);
        });
    }

    _getWatchTarget(rule) {
        let targetType = '';
        if (rule.watch_target_type == 'artifact') {
            targetType = 'Every Artifact';
        } else if (rule.watch_target_type == 'builds') {
            targetType = 'All Builds';
        } else {
            targetType = rule.watch_art_id + '::' + rule.watch_target_type + '::' + rule.watch_target_name;
        }

        return targetType;

    }

    _getAlerts(pagination) {

        let queryP = this.currentTab === 'user' ? {} : {allusers: true};
        const alertFilter = this.$location.$$search.filter;


        if (alertFilter && this.currentTab !== 'user') {

            queryP = _.extend({filter: alertFilter}, queryP);
        }
        pagination = pagination || this.defaultPagination;

        let promise = '';
        _.extend(queryP, pagination);

        if (alertFilter) {
            promise = this.alertsDao.getFiltered(queryP).$promise;
            this.isFilteredPage = true;
        } else {
            this.isFilteredPage = false;
            promise = this.alertsDao.get(queryP).$promise;
        }


        return promise;
    }

    setTabCounter(watchCount = 0) {

        this.alertsDao.getCount({$no_spinner: true}).$promise.then((response) => {
            this.tabsDict.ignoreRules = this.baseTabsDict.ignoreRules + ` (${this.$filter('number')(
                response.ignore_rules
)})`;
            this.tabsDict.watchers = this.baseTabsDict.watchers + ` (${this.$filter('number')(watchCount)})`;

            this.allUserAlerts = response.user_alerts;

        });

    }

    _getIgnoreActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteIgnoreRule(row),
                visibleWhen: (row) => row.permissions.deletable
            }

        ];
    }


    deleteIgnoreRule(rule) {
        this.modal.confirm('Are you sure you want to delete this ignore rule ?')
            .then(() => {
                this.ignoreDao.deleteIgnore({}, {id: rule.id}).$promise.then((res) => {
                    this._getIgnoreRules();
                    this.setTabCounter();
                });
            });
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/watchers/watchers.controller.js